/** Copyright (c) 2021 T. Rowe Price. All rights reserved. */
export const getSelections = (state) => state.selections;

export const getOnlyBrokerageSelected = (state) =>
  state.selections.brokerageOnly;
export const getOnlyActivePlusSelected = (state) =>
  state.selections.activePlusOnly;
